module.exports = __webpack_public_path__ + "assets/img/wx.13389733.png";